import { Button } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
const NotFound = () => {

  const navigate = useNavigate();

  const handleHomeClick = () => {
    navigate("/");
  };

  return (
    <div className="notfound-container" style={styles.container}>
      <h1 style={styles.title}>Page Missing — But Expert Advisors Are Here!</h1>
      <p style={styles.text}>
        Looks like this page doesn’t exist anymore. At{" "}
        <strong>Shatrunjay Financial Advisors</strong>, we’re here to guide you
        with trusted investment advice and smart financial planning.
          </p>
            <Button
                variant="warning"
                size="lg"
                onClick={handleHomeClick}
                style={{fontWeight:"bold"}}
              >
                Back to Home
              </Button>
    </div>
  );
};

const styles = {
  container: {
    textAlign: "center",
    padding: "100px 20px",
    backgroundColor: "#f9fafb",
    minHeight: "80vh",
  },
  title: {
    fontSize: "2rem",
    fontWeight: "700",
    marginBottom: "20px",
    color: "#1e293b",
  },
  text: {
    fontSize: "1.1rem",
    maxWidth: "600px",
    margin: "0 auto 30px",
    color: "#475569",
  },
  button: {
    display: "inline-block",
    textDecoration: "none",
    backgroundColor: "#2563eb",
    color: "#fff",
    padding: "12px 24px",
    borderRadius: "8px",
    fontWeight: "500",
  },
};

export default NotFound;
